export const isMobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
export const isAuthor = () => (window.Granite && window.window.Granite.author ? true : false);
